import NavBar from "./navBar";
import HeroSection from "./HeroSection";
import Features from "./Features";
import Integration from "./Integration";
import WhoWeServe from "./WhoWeServe";
import Awards from "./Awards";
import ContactUs from "./ContactUs";
import Footer from "./Footer";
import HowItWorks from "./HowItWorks";
export default function LandingPage() {
  return (
    <div className="w-full h-screen mx-auto overflow-x-hidden  font-raleway bg-lightBlue">
      <NavBar />
      <div className="px-6 md:px-12 xl:px-32 max-w-[2400px] mx-auto">
        <HeroSection />
        <Features />
      </div>
      <HowItWorks />
      <div className="px-6 md:px-12 xl:px-32 max-w-[2400px] mx-auto">
        <Integration />
        <WhoWeServe />
        <Awards />
      </div>
      <ContactUs />
      <Footer />
      <footer className="bg-lightBlue text-white text-center py-4">
        <p className="text-sm">© 2025 Ledgerate. All rights reserved</p>
      </footer>
    </div>
  );
}
